import {
  type IssueTemplateFilteringDtoOptions,
  type IssueTemplates200Response,
  IssueTemplateSortingDtoOptions,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useQuery } from '@tanstack/react-query';

type ListIssueTemplatesQueryParameters = {
  sort?: IssueTemplateSortingDtoOptions;
  filter?: IssueTemplateFilteringDtoOptions;
  page?: number;
  limit?: number;
  enabled?: boolean;
};

export function useIssueTemplates({
  page = 0,
  limit = 10,
  filter,
  sort,
  enabled = true,
}: ListIssueTemplatesQueryParameters) {
  const api = useApi();

  return useQuery<IssueTemplates200Response, ExtendedAxiosError>({
    queryKey: ['issue-templates', sort, filter, page, limit],
    queryFn: () =>
      api.issueTemplatesApi
        .issueTemplates(sort, filter, page, limit)
        .then((r) => r.data),
    enabled,
    meta: {
      handleError: true,
    },
  });
}
